<template>
  <span>
    <b-button class="mr-2"
              variant="edit"
              @click="showTaskModal(task)"
              qid="delete-s-cancel-button"
              v-if="!editIcon"
    >
      <span v-if="task">
        <font-awesome-icon icon="pen"/>
      </span>
      <span v-if="!task">
        {{ $t('tasks.open_first_task') }}
      </span>
    </b-button>

    <span v-else @click="showTaskModal(task)">
      <span v-if="buttonStyle">
        <span class="btn btn-sm btn-success cursor-pointer">
          {{ $t('tasks.open_label') }}
        </span>
      </span>
      <span v-else>
        <font-awesome-icon icon="info-circle" class="text-primary"/>
        {{ $t('tasks.open_label') }}
      </span>
    </span>

    <!-- Task panel, in the engagement task panel's design (US 9478) -->
    <TaskPanelFrame ref="task-modal"
                    qid="update-task-panel"
                    :crumb="selectedTask && selectedTask.project ? [selectedTask.project.title, selectedTask.model ? selectedTask.model.name : ''] : []"
                    :title="selectedTask && selectedTask.title ? $t('tasks.values.' + $options.filters.slugify(selectedTask.title)) : ''"
                    :status="selectedTask ? selectedTask.status : ''"
                    :users="selectedTask && selectedTask.users ? selectedTask.users : []"
                    :due-date="selectedTask && selectedTask.project ? selectedTask.project.end_date : ''"
                    @close="hideTaskModal"
    >
      <template #meta>
        <span v-if="selectedTask && selectedTask.model">
          <a href="#" class="v2-link" @click.prevent="navigateToTask(selectedTask)" data-qid="update-task-panel-asset">
            <font-awesome-icon :icon="assetIcon(selectedTask.model)" class="mr-1"/>{{ selectedTask.model.name }}
          </a>
        </span>
      </template>

      <b-alert v-if="error.length" show variant="danger" qid="create-p-error">{{ error }}</b-alert>

      <TaskDirections :task="selectedTask" kind="update"></TaskDirections>

      <div class="task-panel-sections" v-if="selectedTask && selectedTask.model" data-qid="update-task-panel-form">
        <b-form qid="create-p-form" v-if="selectedTask && selectedTask.model">
          <div class="form-container mt-0 mb-2">

            <div class="row mt-1">

              <!-- Tables container -->
              <div class="col-sm-12">

                <!-- Activities -->
                <div v-if="selectedTask && selectedTask.model && selectedTask.model.who_am_i == 'App\\Activity\\Models\\Activity'">
                  <div v-if="selectedTask.code == 'update_basic_info'">
                    <BasicInfoBlockActivity :object="selectedTask.model" :showOnTask="true" :submitForm="submitForm" :task="selectedTask" @reloadContent="updateTasks"></BasicInfoBlockActivity>
                  </div>
                  <div v-if="selectedTask.code == 'update_description'">
                    <DescriptionBlock :object="selectedTask.model" :showOnTask="true" :task="selectedTask" :submitForm="submitForm"></DescriptionBlock>
                  </div>
                  <div v-if="selectedTask.code == 'update_organization'">
                    <OrganizationsTable :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></OrganizationsTable>
                  </div>
                  <div v-if="selectedTask.code == 'update_policies_and_procedures'">
                    <PoliciesAndProceduresTable :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></PoliciesAndProceduresTable>
                  </div>
                  <div v-if="selectedTask.code == 'update_mapping_description'">
                    <MappingDescriptionBlock :object="selectedTask.model" :showOnTask="true" :task="selectedTask" :submitForm="submitForm"></MappingDescriptionBlock>
                  </div>
                  <div v-if="selectedTask.code == 'update_systems'">
                    <SystemTable :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></SystemTable>
                  </div>
                  <div v-if="selectedTask.code == 'update_third_party_sources'">
                    <ThirdPartySourcesTable :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></ThirdPartySourcesTable>
                  </div>
                  <div v-if="selectedTask.code == 'update_third_party_receivers'">
                    <ThirdPartyReceiversTable :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></ThirdPartyReceiversTable>
                  </div>
                  <div v-if="selectedTask.code == 'update_processing_role'">
                    <ProcessingRole :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></ProcessingRole>
                  </div>
                  <div v-if="selectedTask.code == 'update_data_subject'">
                    <DataSubjectsTable :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></DataSubjectsTable>
                  </div>
                  <div v-if="selectedTask.code == 'update_retention_rule'">
                    <RetentionRulesTable :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></RetentionRulesTable>
                  </div>
                  <div v-if="selectedTask.code == 'update_integrity_check'">
                    <IntegrityCheck :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></IntegrityCheck>
                  </div>
                  <div v-if="selectedTask.code == 'update_processing_type'">
                    <ProcessingType :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></ProcessingType>
                  </div>
                  <div v-if="selectedTask.code == 'update_risk_scenarios'">
                    <RiskScenariosTable :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></RiskScenariosTable>
                  </div>
                  <div v-if="selectedTask.code == 'update_measures'">
                    <ActivityMeasuresTable :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></ActivityMeasuresTable>
                  </div>
                </div>

                <!-- Systems -->
                <div v-if="selectedTask && selectedTask.model && selectedTask.model.who_am_i == 'App\\System\\Models\\System'">
                  <div v-if="selectedTask.code == 'update_basic_info'">
                    <BasicInfoBlockSystem :object="selectedTask.model" :showOnTask="true" :submitForm="submitForm" :task="selectedTask" @reloadContent="updateTasks"></BasicInfoBlockSystem>
                  </div>
                  <div v-if="selectedTask.code == 'update_description'">
                    <DescriptionBlockSystem :object="selectedTask.model" :showOnTask="true" :task="selectedTask" :submitForm="submitForm"></DescriptionBlockSystem>
                  </div>
                  <div v-if="selectedTask.code == 'update_policies_and_procedures'">
                    <PoliciesAndProceduresTableSystem :object="selectedTask.model" :showOnTask="true"></PoliciesAndProceduresTableSystem>
                  </div>
                  <div v-if="selectedTask.code == 'update_third_parties'">
                    <ThirdPartiesTable :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></ThirdPartiesTable>
                  </div>
                  <div v-if="selectedTask.code == 'update_data_objects'">
                    <DataObjectsTable :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></DataObjectsTable>
                  </div>
                  <div v-if="selectedTask.code == 'update_access_control'">
                    <AccessControlTable :system="selectedTask.model" :showOnTask="true"></AccessControlTable>
                  </div>
                  <div v-if="selectedTask.code == 'update_log_management'">
                    <LogManagementTable :system="selectedTask.model" :showOnTask="true" :task="selectedTask"></LogManagementTable>
                  </div>
                  <div v-if="selectedTask.code == 'update_network'">
                    <NetworkTable :system="selectedTask.model" :showOnTask="true" :task="selectedTask"></NetworkTable>
                  </div>
                  <div v-if="selectedTask.code == 'update_data_discovery'">
                    <DataDiscoveryTable :system="selectedTask.model" :showOnTask="true" :task="selectedTask"></DataDiscoveryTable>
                  </div>
                  <div v-if="selectedTask.code == 'update_risk_scenarios'">
                    <RiskScenariosTableSystem :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></RiskScenariosTableSystem>
                  </div>
                  <div v-if="selectedTask.code == 'update_measures'">
                    <SystemMeasuresTable :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></SystemMeasuresTable>
                  </div>
                </div>

                <!-- Processes -->
                <div v-if="selectedTask && selectedTask.model && selectedTask.model.who_am_i == 'App\\Process\\Models\\Process'">
                  <div v-if="selectedTask.code == 'update_basic_info'">
                    <BasicInfoBlockProcess :object="selectedTask.model" :showOnTask="true" :submitForm="submitForm" :task="selectedTask" @reloadContent="updateTasks"></BasicInfoBlockProcess>
                  </div>
                  <div v-if="selectedTask.code == 'update_description'">
                    <DescriptionBlockProcess :object="selectedTask.model" :showOnTask="true" :task="selectedTask" :submitForm="submitForm"></DescriptionBlockProcess>
                  </div>
                  <div v-if="selectedTask.code == 'update_purpose'">
                    <PurposeBlock :object="selectedTask.model" :showOnTask="true" :task="selectedTask" :submitForm="submitForm"></PurposeBlock>
                  </div>
                  <div v-if="selectedTask.code == 'update_policies_and_procedures'">
                    <PoliciesAndProceduresTableProcess :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></PoliciesAndProceduresTableProcess>
                  </div>
                  <div v-if="selectedTask.code == 'update_legal_basis'">
                    <LegalBasisTable :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></LegalBasisTable>
                  </div>
                  <div v-if="selectedTask.code == 'update_information_obligation'">
                    <InformationObligationTable :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></InformationObligationTable>
                  </div>
                  <div v-if="selectedTask.code == 'update_risk_profile'">
                    <Riskprofile :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></Riskprofile>
                  </div>
                  <div v-if="selectedTask.code == 'update_loss_of_confidentiality'">
                    <Confidentiality :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></Confidentiality>
                  </div>
                  <div v-if="selectedTask.code == 'update_loss_of_integrity'">
                    <Integrity :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></Integrity>
                  </div>
                  <div v-if="selectedTask.code == 'update_loss_of_availability'">
                    <Availability :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></Availability>
                  </div>
                  <div v-if="selectedTask.code == 'update_risk_scenarios'" :task="selectedTask">
                    <RiskScenariosTableProcess :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></RiskScenariosTableProcess>
                  </div>
                </div>

                <!-- Third parties -->
                <div v-if="selectedTask && selectedTask.model && selectedTask.model.who_am_i == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'">
                  <div v-if="selectedTask.code == 'update_basic_info'">
                    <BasicInfoBlockTP :object="selectedTask.model" :showOnTask="true" :submitForm="submitForm" :task="selectedTask" @reloadContent="updateTasks"></BasicInfoBlockTP>
                  </div>
                  <div v-if="selectedTask.code == 'update_description'">
                    <DescriptionBlockThirdParty :object="selectedTask.model" :showOnTask="true" :submitForm="submitForm"></DescriptionBlockThirdParty>
                  </div>
                  <div v-if="selectedTask.code == 'update_risk_scenarios'">
                    <RiskScenariosTableThirdParty :object="selectedTask.model" :showOnTask="true"></RiskScenariosTableThirdParty>
                  </div>
                  <div v-if="selectedTask.code == 'update_documents'">
                    <DocumentsTableThirdParty :object="selectedTask.model" :showOnTask="true"></DocumentsTableThirdParty>
                  </div>
                  <div v-if="selectedTask.code == 'update_contacts'">
                    <ContactsTableThirdParty :object="selectedTask.model" :showOnTask="true"></ContactsTableThirdParty>
                  </div>
                  <div v-if="selectedTask.code == 'update_measures'">
                    <MeasuresTableThirdParty :object="selectedTask.model" :showOnTask="true"></MeasuresTableThirdParty>
                  </div>
                  <div v-if="selectedTask.code == 'update_subdata_processors'">
                    <SubDataProcessors :object="selectedTask.model" :showOnTask="true"></SubDataProcessors>
                  </div>
                  <div v-if="selectedTask.code == 'update_data_processor_agreement'">
                    <DataProcessorAgreement :object="selectedTask.model" :showOnTask="true"></DataProcessorAgreement>
                  </div>
                </div>

                <!-- Policies and procedures -->
                <div v-if="selectedTask && selectedTask.model && selectedTask.model.who_am_i == 'App\\Maintenance\\Policy\\Models\\Policy'">
                  <div v-if="selectedTask.code == 'update_basic_info'">
                    <BasicInfoBlockPolicy :object="selectedTask.model" :showOnTask="true" :submitForm="submitForm" @reloadContent="updateTasks"></BasicInfoBlockPolicy>
                  </div>
                  <div v-if="selectedTask.code == 'update_description'">
                    <DescriptionBlockPolicy :object="selectedTask.model" :showOnTask="true" :submitForm="submitForm"></DescriptionBlockPolicy>
                  </div>
                  <div v-if="selectedTask.code == 'update_documents'">
                    <DocumentsTablePolicy :object="selectedTask.model" :showOnTask="true"></DocumentsTablePolicy>
                  </div>
                </div>

              </div>

            </div>

          </div>

        </b-form>
      </div>

      <template #rail>
        <RelatedAssetTasks v-if="selectedTask && selectedTask.id" :task="selectedTask" @open="switchTask"></RelatedAssetTasks>
        <TaskPanelHelp v-if="selectedTask && selectedTask.project"
                       :project="selectedTask.project"
                       :can-open-project="isOwner(selectedTask.project)"
                       :guide="getGuide(selectedTask.code) ? wpGuide : null"
                       :welcome-guide="welcomeGuide"
                       @open-guide="openGuide()"
                       @open-welcome="openWelcomePage()"
                       @download="downloadMedia"
        ></TaskPanelHelp>
      </template>

      <template #hint>
        <span v-if="selectedTask && selectedTask.project">{{ $t('projects.hero.task_progress') }} <b>{{ project_progress }}%</b></span>
      </template>
      <template #actions>
        <b-button variant="secondary"
                  v-if="selectedTask.status != 'completed'"
                  @click="saveTask()"
                  :disabled="buttonDisabled"
                  qid="create-p-cancel-button"
        >{{ $t('system.close') }}</b-button>
        <b-button variant="success"
                  v-if="selectedTask.status != 'completed'"
                  @click="completeTask()"
                  :disabled="buttonDisabled"
                  qid="create-p-complete-button"
        ><font-awesome-icon icon="check" class="mr-1"/>{{ $t('tasks.modal.complete') }}</b-button>
        <b-button variant="success"
                  v-if="selectedTask.status == 'completed'"
                  @click="saveTask()"
                  :disabled="buttonDisabled"
                  qid="create-p-save-button"
        >{{ $t('system.save') }}</b-button>
      </template>
    </TaskPanelFrame>


    <ConfirmRemoveAttachment
        :object="selectedFile"
        :show="showDeleteAttachmentModal"
        type="file"
        @closeConfirmModal="closeDeleteAttachmentModal"
    ></ConfirmRemoveAttachment>

    <ConfirmRemoveAttachment
        :object="selectedLink"
        :show="showDeleteLinkModal"
        type="link"
        @closeConfirmModal="closeDeleteLinkModal"
    ></ConfirmRemoveAttachment>

    <GuideViewModal
        :guide="selectedGuide"
        :showModal="viewGuideModal"
        @closeViewModal="closeViewGuideModal"
    ></GuideViewModal>

    <GuideWatchVideoModal
        :guide="selectedGuide"
        :showModal="viewWatchVideoModal"
        @closeWatchVideoModal="closeWatchVideoGuideModal"
    ></GuideWatchVideoModal>

    <ShowMoreModal
        :items="selectedItem.users"
        :show="showUsersModal"
        @closeViewModal="closeUsersModal"
        type="users"
    ></ShowMoreModal>

  </span>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import RelatedAssetTasks from '@/components/tasks/RelatedAssetTasks.vue';
  import TaskPanelFrame from '@/components/tasks/TaskPanelFrame.vue';
  import TaskPanelHelp from '@/components/tasks/TaskPanelHelp.vue';
  import TaskDirections from '@/components/tasks/TaskDirections.vue';
  import { assetIcon } from '@/components/tasks/taskPanel.js';
  import Datepicker from 'vuejs-datepicker';
  import {config} from '@/config.js';
  import ConfirmRemoveAttachment from '@/components/ConfirmRemoveAttachment.vue';
  import GuideViewModal from '@/components/guide/GuideViewModal.vue';
  import GuideWatchVideoModal from '@/components/guide/GuideWatchVideoModal.vue';
  import Avatar from '@/components/Avatar.vue';
  import ShowMoreModal from '@/components/ShowMoreModal.vue';
  import roleCheck from "@/util/ACL/roleCheck"


  // Imports of components are moved to components block
  // Because of circular references between components


  export default {
    name: 'UpdateSingleTaskModal',
    data: function() {
      return {
        taskForm: {
          remarks: ''
        },
        selectedTask: [],
        taskList: [],
        selectedAnswer: [],
        allAnswers: [
          { name: this.$t('tasks.modal.pass'), value: 'pass' },
          { name: this.$t('tasks.modal.fail'), value: 'fail' }
        ],
        buttonDisabled: false,
        selectedFile: {},
        selectedLink: {},
        showDeleteAttachmentModal: false,
        showDeleteLinkModal: false,
        showInput: false,
        showSingleLinkLabel: true,
        inputLink: '',
        descriptionLength: config.descriptionLength,
        showFullProjectMessage: false,
        showFullGuideDescription: false,
        showFullGenericControlDescription: false,
        showFullGenericControlPassedDescription: false,
        showFullGenericControlFailedDescription: false,
        error: '',
        selectedGuide: {},
        viewGuideModal: false,
        viewWatchVideoModal: false,
        myGuides: [],
        project_progress: 0,
        taskCompleted: false,
        submitForm: false,
        updatePageOnClose: false,
        welcomeGuide: {},
        wpGuide: {},
        selectedItem: {},
        showUsersModal: false
      }
    },
    props: {
      task: {},
      type: {},
      tasks: {},
      editIcon: {},
      activeGuide: {},
      buttonStyle: {}
    },
    components: {
      TaskPanelFrame,
      TaskPanelHelp,
      TaskDirections,
      RelatedAssetTasks,
      Datepicker,
      ConfirmRemoveAttachment,
      GuideViewModal,
      GuideWatchVideoModal,
      Avatar,
      ShowMoreModal,
      DataSubjectsTable: () => import('@/views/Activities/DataSubjectsTable.vue'),
      RetentionRulesTable: () => import('@/views/Activities/RetentionRulesTable.vue'),
      SystemTable: () => import('@/views/Activities/SystemTable.vue'),
      ThirdPartySourcesTable: () => import('@/views/Activities/ThirdPartySourcesTable.vue'),
      ThirdPartyReceiversTable: () => import('@/views/Activities/ThirdPartyReceiversTable.vue'),
      IntegrityCheck: () => import('@/views/Activities/IntegrityCheck.vue'),
      ProcessingType: () => import('@/views/Activities/ProcessingType.vue'),
      ProcessingRole: () => import('@/views/Activities/ProcessingRole.vue'),
      RiskScenariosTable: () => import('@/views/Activities/RiskScenariosTable.vue'),
      DataDiscoveryTable: () => import('@/views/Systems/DataDiscoveryTable.vue'),
      AccessControlTable: () => import('@/views/Systems/AccessControlTable.vue'),
      NetworkTable: () => import('@/views/Systems/NetworkTable.vue'),
      LogManagementTable: () => import('@/views/Systems/LogManagementTable.vue'),
      RiskScenariosTableSystem: () => import('@/views/Systems/RiskScenariosTable.vue'),
      Confidentiality: () => import('@/views/Processes/Confidentiality.vue'),
      Riskprofile: () => import('@/views/Processes/Riskprofile.vue'),
      Integrity: () => import('@/views/Processes/Integrity.vue'),
      Availability: () => import('@/views/Processes/Availability.vue'),
      RiskScenariosTableProcess: () => import('@/views/Processes/RiskScenariosTable.vue'),
      PoliciesAndProceduresTable: () => import('@/views/Activities/PoliciesAndProceduresTable.vue'),
      OrganizationsTable: () => import('@/views/Activities/OrganizationsTable.vue'),
      PoliciesAndProceduresTableSystem: () => import('@/views/Systems/PoliciesAndProceduresTable.vue'),
      ThirdPartiesTable: () => import('@/views/Systems/ThirdPartiesTable.vue'),
      DataObjectsTable: () => import('@/views/Systems/DataObjectsTable.vue'),
      DescriptionBlockSystem: () => import('@/views/Systems/DescriptionBlock.vue'),
      DescriptionBlock: () => import('@/views/Activities/DescriptionBlock.vue'),
      MappingDescriptionBlock: () => import('@/views/Activities/MappingDescriptionBlock.vue'),
      DescriptionBlockProcess: () => import('@/views/Processes/DescriptionBlock.vue'),
      PurposeBlock: () => import('@/views/Processes/PurposeBlock.vue'),
      PoliciesAndProceduresTableProcess: () => import('@/views/Processes/PoliciesAndProceduresTable.vue'),
      LegalBasisTable: () => import('@/views/Processes/LegalBasisTable.vue'),
      InformationObligationTable: () => import('@/views/Processes/InformationObligationTable.vue'),
      BasicInfoBlockTP: () => import('@/views/ThirdParty/BasicInfoTaskBlock.vue'),
      BasicInfoBlockProcess: () => import('@/views/Processes/BasicInfoTaskBlock.vue'),
      BasicInfoBlockSystem: () => import('@/views/Systems/BasicInfoTaskBlock.vue'),
      RiskScenariosTableThirdParty: () => import('@/views/ThirdParty/RiskScenariosTable.vue'),
      SystemMeasuresTable: () => import('@/views/Systems/MeasuresTable.vue'),
      ActivityMeasuresTable: () => import('@/views/Activities/MeasuresTable.vue'),
      BasicInfoBlockActivity: () => import('@/views/Activities/BasicInfoTaskBlock.vue'),
      DescriptionBlockPolicy: () => import('@/views/Policies/DescriptionBlock.vue'),
      BasicInfoBlockPolicy: () => import('@/views/Policies/BasicInfoTaskBlock.vue'),
      DocumentsTablePolicy: () => import('@/views/Policies/DocumentsTable.vue'),
      DescriptionBlockThirdParty: () => import('@/views/ThirdParty/DescriptionBlock.vue'),
      DocumentsTableThirdParty: () => import('@/views/ThirdParty/DocumentsTable.vue'),
      ContactsTableThirdParty: () => import('@/views/ThirdParty/ContactsTable.vue'),
      MeasuresTableThirdParty: () => import('@/views/ThirdParty/MeasuresTable.vue'),
      SubDataProcessors: () => import('@/views/ThirdParty/SubDataProcessors.vue'),
      DataProcessorAgreement: () => import('@/views/ThirdParty/DataProcessorAgreement.vue')

    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getUser() {
        return this.$store.state.user
      },
      getWordpressLink() {
        return this.$store.state.wordpressLink
      },
    },
    watch: {
      getClient: function () {

      }
    },
    methods: {
      assetIcon,
      openGuide() {
        if (this.wpGuide && this.wpGuide.link) {
          window.open(this.wpGuide.link, '_blank')
        }
      },
      isOwner(object) {
        let self = this;
        let allow = false;
        let existingUser = _.find(object.users, function(user) {
          return user.id == self.getUser.id
        });

        if (existingUser) {
          allow = true
        } else {
          if (roleCheck('Client admin') || roleCheck('Partition admin') || this.getUser.isAdmin) {
            allow = true
          }
        }

        return allow
      },
      getDifference(endDate) {
        var moment = require('moment');
        let currentDate = moment()
        endDate = moment(endDate);
        let difference = endDate.diff(currentDate, 'days');
        return difference;
      },
      getReducedUsers(users) {
        let reducedUsers = []
        if (users) {
          if (users.length > 3) {
            reducedUsers = _.cloneDeep(users);
            reducedUsers = reducedUsers.slice(0, 3);
          } else {
            reducedUsers = users;
          }
        }
        return reducedUsers;
      },
      openUsersModal(object) {
        this.selectedItem = object
        this.showUsersModal = true
      },
      closeUsersModal() {
        this.selectedItem = {}
        this.showUsersModal = false
      },
      showTaskModal(object) {

        let self = this;
        this.error = '';

        if (object != null) {
          self.selectedTask = object
        }

        if (object == null && this.tasks && this.tasks.length) {
          self.selectedTask = this.tasks[0]
        }

        this.loadGuides(this.selectedTask.code)

        // A task from a list comes without its project, which the dialog shows: open it once the whole task is loaded
        if (!this.selectedTask.project) {
          this.loadTaskById(this.selectedTask.id, true).then(function(loaded) {
            if (loaded) {
              self.populateForm()
              self.$refs['task-modal'].show()
              self.loadTaskGuide()
            }
          });
          return;
        }

        this.loadTaskById(this.selectedTask.id, true);
        this.populateForm()
        this.$refs['task-modal'].show()
        this.loadTaskGuide()
      },
      updateTasks(model) {
        this.updatePageOnClose = true;
      },
      // Opens another task on the same asset in the panel (US 9478)
      switchTask(task) {
        this.error = '';
        this.selectedTask = task;
        this.loadTaskById(task.id);
      },
      hideTaskModal() {
        // Kept so the task can be opened again from the sidebar
        this.$store.commit('storeLastClosedTask', this.selectedTask);
        let self = this;
        this.error = '';

        setTimeout(function(){
          self.$emit('reloadContent');
          self.selectedTask = {}
        }, 800);

        if (!this.taskCompleted && this.selectedTask.status != 'completed') {
          this.minimizeTask();
        }

        if (this.taskCompleted) {
          self.$store.commit('storeReloadTasks');
        }

        if (this.updatePageOnClose) {
          this.$store.commit('storeUpdatePage', true);
        }

        this.$refs['task-modal'].hide()
      },
      populateForm() {
        let self = this;

        self.taskForm.remarks = self.selectedTask.remarks

        self.selectedAnswer = []
        if (self.selectedTask.response) {
          self.selectedAnswer = _.find(self.allAnswers, function(item) {
            if(item.value === self.selectedTask.response){
              return self.selectedTask.response;
            }
          });
        }
      },
      openWelcomePage() {
        this.showViewGuideModal(this.welcomeGuide)
      },
      loadTaskGuide() {
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';
        let self = this;
        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'Task',
            scope: 'update_task',
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.welcomeGuide = response.data.items[0]
          }
        }, function() {});
      },
      navigateToTask(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
        if (object.model_type == 'App\\Activity\\Models\\Activity') {
          this.$router.push({ name: 'activities.view', params: { slug: object.model.slug }, query: { task: object.id }})
        }
        if (object.model_type == 'App\\Process\\Models\\Process') {
          this.$router.push({ name: 'processes.view', params: { slug: object.model.slug }, query: { task: object.id }})
        }
        if (object.model_type == 'App\\System\\Models\\System') {
          this.$router.push({ name: 'systems.view', params: { slug: object.model.slug, }, query: { task: object.id }})
        }
        if (object.model_type == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty') {
          this.$router.push({ name: 'contracts.view', params: { slug: object.model.slug, }, query: { task: object.id }})
        }
        if (object.model_type == 'App\\Maintenance\\Policy\\Models\\Policy') {
          this.$router.push({ name: 'policies.view', params: { slug: object.model.slug, }, query: { task: object.id }})
        }
      },
      minimizeTask() {
        var element = document.getElementsByClassName('modal');
        // Task panels aren't modals (US 9478)
        if (element.length) {
          element[0].classList.add("bottom-left");
        }
        //this.submitForm = true
        this.$store.commit('storeLastClosedTask', this.selectedTask);
      },
      saveTask() {
        this.submitForm = true
        this.hideTaskModal()
      },
      showViewGuideModal(object) {
        this.selectedGuide = object
        this.viewGuideModal = true
      },
      closeViewGuideModal() {
        this.selectedGuide = ''
        this.viewGuideModal = false
      },
      showWatchVideoGuideModal(object) {
        this.selectedGuide = object
        this.viewWatchVideoModal = true
      },
      closeWatchVideoGuideModal() {
        this.selectedGuide = ''
        this.viewWatchVideoModal = false
      },
      completeTask() {
        this.buttonDisabled = true;
        this.submitForm = true
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        this.error = ''

        piincHttp.put('tasks/' + this.selectedTask.id, {
          status: 'completed'
        }).then(function(response) {
          self.buttonDisabled = false;

          if (self.taskList.length > 1) {
            let index = _.findIndex(self.taskList, function(o) { return o.id == self.selectedTask.id })
            if (index < self.taskList.length - 1) {
              self.selectedTask = self.taskList[index + 1]
            } else {
              self.selectedTask = self.taskList[0]
            }
            self.taskList.splice(index, 1);
            self.loadTaskById(self.selectedTask.id);
          } else {
            self.taskCompleted = true;
            self.$store.commit('storeTaskToolbarState', false);
            if (self.selectedTask.code == 'update_basic_info') {
              self.$store.commit('storeUpdatePage', true);
            }
            self.hideTaskModal()
          }
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      },
      previousTask() {
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        this.error = ''

        let index = _.findIndex(self.taskList, function(o) { return o.id == self.selectedTask.id })
        if (index > 0) {
          this.selectedTask = this.taskList[index - 1]
        } else {
          this.selectedTask = this.taskList[this.taskList.length - 1]
        }
        self.loadTaskById(this.selectedTask.id);
      },
      nextTask() {
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        this.error = ''

        let index = _.findIndex(self.taskList, function(o) { return o.id == self.selectedTask.id })
        if (index < this.taskList.length - 1) {
          this.selectedTask = this.taskList[index + 1]
        } else {
          this.selectedTask = this.taskList[0]
        }
        self.loadTaskById(self.selectedTask.id);
      },
      resetFile() {
        let imagefile = document.querySelector('#file');
        imagefile.value = '';
      },
      loadTaskById(id, ignorePopulate) {
        let self = this;
        return piincHttp.get('tasks/' + id).then(function(response) {
          self.selectedTask = response.data;
          self.project_progress = self.selectedTask.project.user_progress.progress;
          self.loadGuides(self.selectedTask.code)
          if (!ignorePopulate) {
            self.populateForm()
          }
          return true;
        }, function() {
          return false;
        });
      },
      openDeleteAttachmentModal(object) {
        this.selectedFile = object
        this.showDeleteAttachmentModal = true
      },
      closeDeleteAttachmentModal () {
        this.selectedFile = {}
        this.showDeleteAttachmentModal = false;
        this.loadTaskById(this.selectedTask.id, true);
      },
      openDeleteLinkModal(object) {
        this.selectedLink = object
        this.showDeleteLinkModal = true
      },
      closeDeleteLinkModal () {
        this.selectedLink = {}
        this.showDeleteLinkModal = false;
        this.loadTaskById(this.selectedTask.id, true);
      },
      downloadMedia(object){
        piincHttp.get('documents/' + object.id + '/download', {
          responseType: 'blob',
          params:
            {
              client: this.getClient.slug,
              task: this.selectedTask.id
            }
        }).then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = object.file_name;

          link.click();
          link.remove()
          window.URL.revokeObjectURL(url);
        }, function() {});
      },
      downloadScopeMedia(object){
        piincHttp.get('tasks/'+this.selectedTask.id+'/documents/' + object.id + '/download', {
          responseType: 'blob',
          params:
            {
              client: this.getClient.slug
            }
        }).then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = object.file_name;

          link.click();
          link.remove()
          window.URL.revokeObjectURL(url);
        }, function() {});
      },
      onFileChange(file) {
        let files = file.target.files;
        let self = this;
        let formData = new FormData();
        let sizeError = false;

        for (var i = 0; i < files.length; i++) {
          // Equal to 10 MB
          if (files[i].size > 10485760) {
            sizeError = true;
          }
          formData.append('document[]', files[i]);
        }

        formData.append("name", "documents");
        formData.append("model_type", this.selectedTask.who_am_i);
        formData.append("model_id", this.selectedTask.id);

        if (sizeError) {
          this.error = this.$t('system.file_size')
        } else {
          piincHttp.post('documents', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function() {
            self.error = ''
            self.loadTaskById(self.selectedTask.id, true);
          }, function(error) {
            self.error = error.data.message;
            if (error.data.errors['document.0']) {
              self.error += ' ' + error.data.errors['document.0'][0]
            }
          })
        }
      },
      navigateToProject(task) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', task);
        this.$router.push({ name: 'projects.view', params: { slug: task.project.slug }})
      },
      getGuide(code) {
        if (code == 'update_mapping_description') {
          code = 'update_data_mapping_description'
        }
        let existingGuide = {}
        if (this.selectedTask && this.selectedTask.model && this.selectedTask.model.who_am_i == 'App\\Process\\Models\\Process') {
          existingGuide = _.find(this.myGuides, function(object) {
            return object.scope == code && object.enabled
          });
        }
        if (this.selectedTask && this.selectedTask.model && this.selectedTask.model.who_am_i == 'App\\System\\Models\\System') {
          existingGuide = _.find(this.myGuides, function(object) {
            return object.scope == code && object.enabled
          });
        }
        if (this.selectedTask && this.selectedTask.model && this.selectedTask.model.who_am_i == 'App\\Activity\\Models\\Activity') {
          existingGuide = _.find(this.myGuides, function(object) {
            return object.scope == code && object.enabled
          });
        }
        if (this.selectedTask && this.selectedTask.model && this.selectedTask.model.who_am_i == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty') {
          existingGuide = _.find(this.myGuides, function(object) {
            return object.scope == code && object.enabled
          });
        }
        if (this.selectedTask && this.selectedTask.model && this.selectedTask.model.who_am_i == 'App\\Maintenance\\Policy\\Models\\Policy') {
          existingGuide = _.find(this.myGuides, function(object) {
            return object.scope == code && object.enabled
          });
        }

        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        let type = ''

        if (this.selectedTask && this.selectedTask.model && this.selectedTask.model.who_am_i == 'App\\Process\\Models\\Process') {
          type = 'Process'
        }
        if (this.selectedTask && this.selectedTask.model && this.selectedTask.model.who_am_i == 'App\\System\\Models\\System') {
          type = 'System'
        }
        if (this.selectedTask && this.selectedTask.model && this.selectedTask.model.who_am_i == 'App\\Activity\\Models\\Activity') {
          type = 'Activity'
        }
        if (this.selectedTask && this.selectedTask.model && this.selectedTask.model.who_am_i == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty') {
          type = 'Third party'
        }
        if (this.selectedTask && this.selectedTask.model && this.selectedTask.model.who_am_i == 'App\\Maintenance\\Policy\\Models\\Policy') {
          type = 'Policy'
        }

        if (code == 'update_mapping_description') {
          code = 'update_data_mapping_description'
        }

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: type,
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
            piincHttp.get(self.getWordpressLink + response.data.items[0].external_id).then(function(response) {
              self.wpGuide = response.data
            }, function() {});
          }
        }, function() {});
      },
    },
    created () {

    }
  }
</script>
